import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout({ children }: { children: ReactNode; transparentNav?: boolean }) {
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-bg text-ink flex flex-col">
      <Navbar />
      <main key={loc.pathname} className="page-transition">{children}</main>
      <Footer />
    </div>
  );
}